import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { RxPlus } from "react-icons/rx";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  MenuItem,
  Popover,
  gridClasses,
  styled,
} from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Department.scss";
import AddEditDepartment from "../../../components/Department/AddForm/AddEditDepartment";
import DeleteModal from "../../../components/Model/DeleteModal";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import { HttpService } from "../../../service/HttpService";
import { useAuth } from "../../../context/AuthProvider";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { useFilter } from "../../../context/FilterProvider";
import { handleDownloadDepartmentExcel } from "../DownloadDepartment";
import { FaFileExcel } from "react-icons/fa";

const Department = () => {
  const navigate = useNavigate();
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [open, setOpen] = React.useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [department, setDepartment] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [clickeddepartment, setClickeddepartment] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [DeleteDepartment, setDeleteDepartment] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [loading, setLoading] = useState(false);
  const { company_id, location_id } = useFilter();
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [columnName, setColumnName] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const fetchDepartment = async () => {
    setLoading(true);
    try {
      const response = await httpService.get(
        `department/get_department?page=${
          page + 1
        }&pageSize=${pageSize}&search=${searchData}&sortBy=${columnName}&sortOrder=${sortOrder}`
      );
      setDepartment(response?.data?.data);
      // setSearchData(response?.data);
      setRowCount(response?.data?.pagination?.totalRecords);
      setTimeout(() => {
        setLoading(false);
      }, 300);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartment();
  }, [
    company_id,
    location_id,
    showLoginPopup,
    page,
    pageSize,
    searchData,
    columnName,
    sortOrder,
  ]);

  const handleOpen = () => {
    setOpen(true);
    setIsAdd(true);
    setClickeddepartment("");
  };

  const handleClose = () => {
    setOpen(false);
    setIsAdd(false);
    setClickeddepartment("");
    setOpenDelete(false);
    fetchDepartment();
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    // Navigate to the encrypted URL
    navigate(`view/${urlEncodedId}`);
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  // const searchDepartment = (searchTerm) => {
  //   const searchTermLowerCase = searchTerm.toLowerCase();
  //   const results =
  //     department?.length > 0 &&
  //     department?.filter((item) => {
  //       for (let key in item) {
  //         if (
  //           typeof item[key] === "string" &&
  //           item[key].toLowerCase().includes(searchTermLowerCase)
  //         ) {
  //           return true;
  //         }
  //       }
  //       return false;
  //     });
  //   if (results) {
  //     setSearchData(results);
  //   }
  // };

  const HandleDeleteDepartment = async () => {
    if (DeleteDepartment) {
      try {
        const response = await httpService.delete(
          `${"department/delete_department"}/${DeleteDepartment}`
        );
        if (response) {
          navigate("/department");
          toast.success("Department Deleted successfully", {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchDepartment();
      } catch (error) {
        setOpenDelete(false);
        console.error(
          "Error deleting department:",
          error?.response?.data?.error
        );
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const onDownloadClick = async () => {
    try {
      await handleDownloadDepartmentExcel(setShowLoginPopup);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = department?.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]); // Deselect all
    }
    setIsAllSelected(isChecked);
  };

  const deleteSelectedDepartment = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post(
          "department/delete_all_department",
          { departmentIds: selectedId }
        );
        if (response?.success) {
          const messages = response?.data?.combinedMessage
            ? response?.data?.combinedMessage
            : response?.data?.message;
          response?.data?.combinedMessage
            ? toast.error(messages, {
                position: "top-right",
              })
            : toast.success(messages, {
                position: "top-right",
              });
        } else {
          throw response;
        }
        setSearchData("");
        fetchLocation();
        setIsAllSelected();
        setSelectedId();
        setAllIds();
        setOpenDeleteModal(false);
      } catch (error) {
        setOpenDeleteModal(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one department", {
        position: "top-right",
      });
    }
  };

  const isIdSelected = (id) => {
    return selectedId?.includes(id);
  };

  const toggleId = (id) => {
    setSelectedId((prev) => {
      if (prev.includes(id)) {
        const updatedSelectedIds = prev.filter((item) => item !== id);
        if (updatedSelectedIds.length < allIds) {
          setIsAllSelected(false);
        }
        return updatedSelectedIds;
      } else {
        const updatedSelectedIds = [...prev, id];
        if (updatedSelectedIds.length === allIds) {
          setIsAllSelected(true);
        }
        return updatedSelectedIds;
      }
    });
  };

  return (
    <>
      {loading && <FullScreenLoader />}

      <div className="department">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Departments</h1>
          </div>
          <div className="button-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={() => handleOpen()}
            >
              <RxPlus /> Add Department{" "}
            </button>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <Button
            className="btn btn-delete"
            onClick={() => {
              if (selectedId?.length > 0) {
                setOpenDeleteModal(true);
              } else {
                toast.error("Please select atleast one department", {
                  position: "top-right",
                });
              }
            }}
          >
            Delete
          </Button>
          <div className="d-flex flex-row">
            <Button
              variant="contained"
              color="primary"
              onClick={() => onDownloadClick()}
              startIcon={<FaFileExcel />}
              className="me-3"
            >
              Download
            </Button>
            <div className="header_search-wrap">
              <div className="header_search_bar common_content">
                <div className="input-group input_group">
                  <button className="btn search-btn search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <circle
                        cx="9.98856"
                        cy="9.98856"
                        r="8.98856"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.2402 16.7071L19.7643 20.222"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="search"
                    className="form-control form_control"
                    placeholder="Search..."
                    aria-label="Search"
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            height: `${department?.length > 0 ? "" : "200px"}`,
            width: "100%",
          }}
        >
          <DataGrid
            className="department-table"
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={
              department?.length > 0 &&
              department?.map((department, index) => ({
                ...department,
                id: department.id,
                sequenceNumber: index + 1,
              }))
            }
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columns={[
              {
                field: "action",
                headerName: "Action",
                align: "center",
                width: 100,
                sortable: false,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e), setDataId(params.row.id);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        key={dataId}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            // console.log(params.row.id);
                            viewPage(dataId);
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">View</div>
                          <HiOutlineEye style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setIsAdd(false);
                            setClickeddepartment(dataId);
                            setOpen(true);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>{" "}
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenDelete(true);
                            setDeleteDepartment(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>{" "}
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
              },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 150,
                align: "center",
                sortable: false,
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      value="Checked"
                      checked={
                        isAllSelected
                          ? true
                          : isIdSelected(params.row.id)
                          ? true
                          : false
                      }
                      onChange={() => toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={isAllSelected}
                        onChange={(e) => handleHeaderCheckboxChange(e)}
                      />
                      <strong>Select All</strong>
                    </>
                  );
                },
              },
              {
                field: "name",
                headerName: "Name",
                flex: 1,
              },
              {
                field: "company_name",
                headerName: "Company",
                flex: 1,
                sortable: true,
                renderCell: (params) => {
                  const { company_name } = params.row;
                  return (
                    <div className="employee-name-weap">
                      <span>{company_name || "--"}</span>
                    </div>
                  );
                },
              },
              {
                field: "location_name",
                headerName: "Location",
                flex: 1,
                sortable: true,
                renderCell: (params) => {
                  const { location_name } = params.row;
                  return (
                    <div className="employee-name-weap">
                      <span>{location_name || "--"}</span>
                    </div>
                  );
                },
              },
              // {
              //   field: "description",
              //   headerName: "Description",
              //   flex: 1,
              //   minWidth: 200,
              //   sortable: false,
              //   disableColumnMenu: true,
              //   renderCell: (params) => {
              //     const { description } = params.row;
              //     return (
              //       <div className="employee-name-weap">
              //         <span>{description || "--"}</span>
              //       </div>
              //     );
              //   },
              // },
            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            onSortModelChange={(e) => {
              if (e && e.length > 0) {
                setsortOrder(e[0].sort);
                setColumnName(e[0].field);
              } else {
                setsortOrder("");
                setColumnName("");
              }
            }}
            paginationMode="server"
            sortingMode="server"
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize: pageSize, page: page }}
            onPaginationModelChange={(event) => {
              setPage(event?.page);
              setPageSize(event?.pageSize);
            }}
            checkboxSelection={false}
            rowSelection={false}
            autoHeight
            {...other}
          />
        </div>
      </div>
      {open === true && (
        <AddEditDepartment
          open={open}
          isAdd={isAdd}
          clickeddepartment={clickeddepartment}
          handleClose={() => handleClose()}
          fetchDepartment={fetchDepartment}
          companyId={company_id}
          locationId={location_id}
        />
      )}
      <DeleteModal
        open={openDelete}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          HandleDeleteDepartment(), setClickeddepartment("");
        }}
      />
      {openDeleteModal && (
        <DeleteModal
          open={openDeleteModal}
          HandleClose={() => setOpenDeleteModal(false)}
          HandleDelete={() => {
            deleteSelectedDepartment();
          }}
        />
      )}
    </>
  );
};

export default Department;
